import Model from '@/models/Model.js';

export default class TimelineCategory extends Model {
    static entity = 'timeline_categories';

    static fields() {
        return {
            id: this.attr(null),
            icon_id: this.attr(null),
            title: this.string(''),

            ...super.fields(),

            icon: this.belongsTo('icons', 'icon_id'),
        };
    }

    static defaultIcon() {
        return 'object-group';
    }
}
